const B = "https://static.prod-images.emergentagent.com/jobs/aeddbfe9-cc57-4506-a415-dcb8bd697136/images/";

export const IMG = {
  heroAlltagsbegleitung: `${B}8e3e868a1fbb58df852b80b65b5c46c7a13c861b5380e8fe12b86096aa0294ef.jpeg`,
  heroPflegeberatung: `${B}2d71836858d5bdd686224748801a6ae220b168a1a9f6e4f144da51c00dd69c0a.jpeg`,
  zielgruppePflegebeduerftige: `${B}b559b4dfa5d906fbe270e7b72f35a5c2ebf2780f9eeccc2990a36cfa4f2308d1.jpeg`,
  zielgruppeAngehoerige: `${B}e15c0f232d56b9ae8dc480ca18d2bce3d983fd8bf153cde3c095e24c206360fa.jpeg`,
  zielgruppeBerufstaetige: `${B}06adad2c54a40338310d4b33edda6bf13e6e08da6b7216a88f970df1c7e9a94f.jpeg`,
  zielgruppeNrw: `${B}976de8df35082ff3e74c40dc6231ea72acd1306e7fc4c31d42ee77699d24e0e3.jpeg`,
  hausnotruf: `${B}f76d9951ee0001a398a806b8b6cb8d8eec76be982f2255b40695c2c229c41b3b.jpeg`,
  umbauDusche: `${B}f85ca7db2ffa667db481c12ac72361de4cfedab46245a5db9f8b85cd1474e28b.jpeg`,
  schulungHero: `${B}d523517626d76603b282d5fb6b246f70ad7664fdca6d3c8059bfdba56c9d3847.jpeg`,
  schulungPraxis: `${B}b8310b34620348b3d7906e03fd9965a6df0212b2428763c04068fb581a578dda.jpeg`,
};

const BLOG = {
  reform: `${B}c2c7730b03cea9e72fdb702505ed2b354eb07a63bf8b726dbfab3e2cd5056a49.jpeg`,
  angehoerige: `${B}6b9fac71c76d00bfa362af397c95dcafadbb6a312b45c365678128baed6bc319.jpeg`,
  beratung: `${B}e0054de20b40dde77c6620763241eea486699d356cb0036f272ee335b2822508.jpeg`,
  leistungen: `${B}0ea16d04bc918d602b3196c9bbd0c9d43744235c69e292ee86422e7247399488.jpeg`,
  sicherheit: `${B}2a5abe5ac706e4a6442b2b67e673b513c791e56be725e796421f45b8aff19319.jpeg`,
  wohnen: `${B}bbd899c1bd770461d6e3d258d052f83546b00ebc8c9ea52c2365d7a125adef97.jpeg`,
};

const CATEGORY_MAP = {
  "Pflegereform": "reform", "Sozialraumbudget": "reform", "NRW": "reform", "Pflegeleistungen": "reform", "Rechner": "reform",
  "Angehörige": "angehoerige", "Pflegebegleitung": "angehoerige", "Betreuung": "angehoerige", "Demenz": "angehoerige", "Alltagshilfe": "angehoerige", "Nachbarschaftshilfe": "angehoerige",
  "Pflegegrad": "beratung", "Antragstellung": "beratung", "Pflegeberatung": "beratung",
  "Entlastungsbetrag": "leistungen", "Verhinderungspflege": "leistungen",
  "Hilfsmittel & Sicherheit": "sicherheit",
  "Wohnen & Umbau": "wohnen",
};

export const getBlogImage = (category) => BLOG[CATEGORY_MAP[category] || "beratung"];
